import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { creerTraducteur, direction, estLangue, } from '@ef2c/i18n';
import { chargerConfigNavigateur, } from '@ef2c/config';
import { Cadre } from './composants/Cadre.js';
import { Bandeau } from './composants/Bandeau.js';
import { Reservations } from './ecrans/Reservations.js';
import { Factures } from './ecrans/Factures.js';
import { Abonnement } from './ecrans/Abonnement.js';
import { Formations } from './ecrans/Formations.js';
import { Introuvable } from './ecrans/Introuvable.js';
import { ecranPour, useChemin } from './routeur.js';
const CLE_LANGUE = 'ef2c.langue';
export function App() {
    const [config, setConfig] = useState();
    const [panne, setPanne] = useState();
    const [langue, setLangue] = useState();
    const [chemin, naviguer] = useChemin();
    // La configuration est lue au runtime, jamais figée au build (§7 bis.2).
    useEffect(() => {
        chargerConfigNavigateur()
            .then((chargee) => {
            setConfig(chargee);
            const memorisee = window.localStorage.getItem(CLE_LANGUE);
            setLangue(memorisee && estLangue(memorisee) ? memorisee : chargee.DEFAULT_LOCALE);
        })
            .catch((erreur) => {
            setPanne(erreur instanceof Error ? erreur.message : String(erreur));
        });
    }, []);
    // La langue pilote l'attribut lang et le sens d'écriture (§8). La police
    // arabe n'est téléchargée que si quelqu'un passe l'interface en arabe.
    useEffect(() => {
        if (!langue)
            return;
        if (langue === 'ar') {
            void import('@fontsource/ibm-plex-sans-arabic/400.css');
            void import('@fontsource/ibm-plex-sans-arabic/600.css');
        }
        document.documentElement.lang = langue;
        document.documentElement.dir = direction(langue);
        window.localStorage.setItem(CLE_LANGUE, langue);
    }, [langue]);
    if (panne !== undefined) {
        // Une application mal configurée s'arrête et le dit : elle ne devine pas
        // une URL d'API (§7 bis.2).
        return (_jsx("div", { className: "plein-ecran", children: _jsxs("div", { className: "etat-vide", children: [_jsx("p", { className: "etat-vide__titre", children: "Configuration introuvable" }), _jsx("p", { children: panne })] }) }));
    }
    if (!config || !langue) {
        return (_jsx("div", { className: "plein-ecran", children: _jsx("p", { children: "Chargement\u2026" }) }));
    }
    const t = creerTraducteur(langue);
    const ecran = ecranPour(chemin);
    const site = (page) => config.urls.webUrl(page);
    return (_jsxs(Cadre, { t: t, langue: langue, changerLangue: setLangue, chemin: ecran?.chemin ?? chemin, naviguer: naviguer, urlSite: site(''), children: [_jsx(Bandeau, { titre: t('app.enPreparation.titre'), texte: t('app.enPreparation.texte') }), ecran?.chemin === '/' && _jsx(Reservations, { t: t, urlReserver: site('reserver') }), ecran?.chemin === '/mes-factures' && _jsx(Factures, { t: t }), ecran?.chemin === '/mon-abonnement' && _jsx(Abonnement, { t: t, urlTarifs: site('tarifs') }), ecran?.chemin === '/mes-formations' && _jsx(Formations, { t: t, urlCatalogue: site('former') }), !ecran && _jsx(Introuvable, { t: t, retour: () => naviguer('/') })] }));
}
//# sourceMappingURL=App.js.map